import { SCOPES } from '../helpers/SCOPES';
import { getProductUuid, getSiteUuid } from '../storage/last-braincube';
function getJwtKey(scope) {
    if (scope === SCOPES.PRODUCT) {
        const productUuid = getProductUuid();
        return productUuid ? `braincube-jwt-product-${productUuid}` : 'braincube-jwt';
    }
    if (scope === SCOPES.SITE) {
        const siteUuid = getSiteUuid();
        return siteUuid ? `braincube-jwt-site-${siteUuid}` : 'braincube-jwt';
    }
    return 'braincube-jwt';
}
function getJwtExpirationDateKey(scope) {
    return `${getJwtKey(scope)}-expiration-date`;
}
export { getJwtKey, getJwtExpirationDateKey };
